// extracted by mini-css-extract-plugin
module.exports = {"secondaryButton":"secondary-button-module--secondary-button--2CrC_","disabled":"secondary-button-module--disabled--1s7KL"};